
const {
  CARD_FORM_BRICKS_ERRORS: {
    SUBMIT_FORM_ERROR,
    MISSING_CARD_DATA,
    MISSING_ISSUER,
  },
  ERROR_SPA,
} = require('../../../../../../constants/app');
const { logErrorFromClient } = require('../../../../../utils/logTags');
const { trackInfo } = require('../../../../../service/api');

const BRICKS_SUBMIT_ERRORS = [
  SUBMIT_FORM_ERROR,
  MISSING_CARD_DATA,
  MISSING_ISSUER,
]

const isSubmissionError = (error) =>
  BRICKS_SUBMIT_ERRORS.includes(error?.reason);



const handleCatchError = (generateTokenError, functionName) => {
  if (isSubmissionError(generateTokenError)) {
    return Promise.resolve();
  }

  const error = generateTokenError instanceof Error
    ? generateTokenError
    : new Error(generateTokenError?.reason || generateTokenError?.message);
  
  if (error.message === 'Not Found'){
    trackInfo(error);
  } else {
    logErrorFromClient(error, ERROR_SPA.CARD_FORM_BRICKS_ERROR, `[CardFormWrapper][${functionName}]`);
  }

  return Promise.reject(error);
}

module.exports = {
  isSubmissionError,
  handleCatchError
};